import { render, staticRenderFns } from "./GroceryListPage.vue?vue&type=template&id=67d678ef&"
import script from "./GroceryListPage.vue?vue&type=script&lang=js&"
export * from "./GroceryListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports